<template>
    <div ref="imageContainer" v-editable="blok" :class="styles" :style="style"></div>
</template>
<script>
export default {
  name: "image-blok",
  props: ["blok"],
  data: () => {
    return {
      style: ''
    }
  },
  computed: {
    styles: function() {
      const b = this.$props.blok;
      return ["image-blok", b.width, b.width || 'default', b.ratio, b.align, b.border, b.styles];
    }
  },
  mounted: function() {
    const rect = this.$refs.imageContainer.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    const image = this.$options.filters.optimizeImage(this.blok.image,width,height);
    this.style = {
      backgroundImage: `url(${image})`
    };
  }
};
</script>